import session from '../../utilities/session.js'
import { JSConn } from '@/utilities/js-conn.js'

export default {
  name: 'SignInForm',
  data () {
    return {
      email: null,
      password: null
    }
  },
  methods: {
    submitForm (evt) {
      evt.preventDefault()
      const jsConn = new JSConn()
      jsConn.formParams = {
        email: this.email,
        password: this.password
      }
      jsConn.apiParams = {
        email: this.email,
        password: this.password
      }
      jsConn.fromRoutePath = this.$router.currentRoute.path
      jsConn.toRoutePath = '/crops'

      session.createSession(jsConn)
    }
  }
}
